export class ObjectHelper {
  static isEmpty(obj: any): boolean {
    return obj ? Object.keys(obj).length === 0 && obj.constructor === Object : true;
  }
}
